export default __webpack_public_path__ + "static/media/triage.475f275c.jpg";